var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.128 1h39.744c1.5 0 2.058.12 2.61.416.475.254.848.627 1.102 1.102.295.552.416 1.11.416 2.61v21.744c0 1.5-.12 2.058-.416 2.61a2.649 2.649 0 0 1-1.102 1.102c-.552.295-1.11.416-2.61.416H5.128c-1.5 0-2.058-.12-2.61-.416a2.649 2.649 0 0 1-1.102-1.102C1.121 28.93 1 28.372 1 26.872V5.128c0-1.5.12-2.058.416-2.61a2.649 2.649 0 0 1 1.102-1.102C3.07 1.121 3.628 1 5.128 1z",
    stroke: "#16216A",
    strokeWidth: 2,
    fill: "#16216A"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.608 10.069a8.247 8.247 0 0 0-2.853-.49c-3.142 0-5.358 1.574-5.376 3.83-.019 1.667 1.58 2.598 2.787 3.154 1.238.568 1.657.93 1.65 1.439-.009.777-.99 1.132-1.905 1.132-1.271 0-1.947-.177-2.993-.609l-.41-.182-.447 2.597c.742.324 2.117.604 3.544.618 3.345 0 5.516-1.555 5.54-3.965.011-1.318-.834-2.323-2.67-3.152-1.113-.537-1.794-.895-1.789-1.439 0-.482.58-.997 1.823-.997a5.899 5.899 0 0 1 2.381.443l.285.134.433-2.513M41.764 9.793h-2.457c-.762 0-1.332.207-1.665.962l-4.725 10.634h3.341s.545-1.43.67-1.742L41 19.65c.095.406.388 1.738.388 1.738h2.952L41.764 9.793zm-3.922 7.48c.264-.67 1.267-3.246 1.267-3.246-.017.033.262-.67.42-1.107l.217 1 .738 3.354h-2.642zM16.22 9.79l-3.114 7.913-.333-1.608c-.578-1.852-2.386-3.863-4.405-4.868l2.846 10.148 3.366-.003L19.59 9.79h-3.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.216 9.784H5.084l-.04.24c3.992.96 6.634 3.283 7.729 6.071l-1.115-5.333c-.193-.735-.75-.952-1.442-.978M18.889 21.384l1.988-11.602h3.183l-1.993 11.602h-3.178"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.63bd0aba.svg";
export { ForwardRef as ReactComponent };